import { CALL_API } from '../middleware/api'

import { fetchEnrolments } from './enrolments.js';

import _ from 'lodash';

export const COURSES_REQUEST = 'COURSES_REQUEST'
export const COURSES_SUCCESS = 'COURSES_SUCCESS'
export const COURSES_FAILURE = 'COURSES_FAILURE'

export const COURSE_REQUEST = 'COURSE_REQUEST'
export const COURSE_SUCCESS = 'COURSE_SUCCESS'
export const COURSE_FAILURE = 'COURSE_FAILURE'

export const fetchCourse = (course_code) => (dispatch, getState) => {
	const user = getState().user;
	const courses = getState().courses;
	const now = Math.floor(Date.now() / 1000);
	
	if(courses && courses.expires >= now && (courses.singles[course_code] || _.includes(courses.fetching_singles, course_code))){
		return null
	}
	
	return dispatch({
		[CALL_API]: {
			types: [COURSE_REQUEST, COURSE_SUCCESS, COURSE_FAILURE],
			endpoint: '/courses/' + course_code,
			method: user.member_no > 0 ? 'POST' : 'GET',
			params: {},
			bad_response: 'Error retrieving course detail from U-MAS database',
			add_data: {
				course_code: course_code
			}
		}
	});
}

const fetchCourses = (from_date, to_date, loggedin) => ({
	[CALL_API]: {
		types: [ COURSES_REQUEST, COURSES_SUCCESS, COURSES_FAILURE ],
		endpoint: '/courses/',
		method: loggedin ? 'POST' : 'GET',
		params: {
			from_date: from_date,
			to_date: to_date,
			simple: false,
		},
		bad_response: 'Error retrieving course list from U-MAS database',
		add_data: {
			from: from_date,
			to: to_date
		}
	}
})

export const loadCourses = (from_date, to_date) => (dispatch, getState) => {
  const user = getState().user;
  const courses = getState().courses;
  
  const now = Math.floor(Date.now() / 1000);
  
  if (courses && (
	(courses.expires >= now && from_date >= courses.from && to_date <= courses.to)
	|| 
	(courses.fetching && courses.fetching_from === from_date && courses.fetching_to === to_date)
	)) {
    return null
  }

  return dispatch(fetchCourses(from_date, to_date, user.member_no > 0)).then(result => {
	  if(result.type === 'COURSES_SUCCESS' && user.member_no > 0){
		  dispatch(fetchEnrolments(from_date, to_date));
	  }
  })
}